import * as React from 'react';
import { IconProps } from '../types';

const IcTick = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M10.227 18c-.32 0-.624-.134-.848-.368l-4.53-4.738a1.305 1.305 0 0 1 0-1.775 1.17 1.17 0 0 1 1.696 0l3.682 3.85 8.228-8.605a1.17 1.17 0 0 1 1.697 0c.464.486.464 1.29 0 1.775l-9.077 9.493a1.173 1.173 0 0 1-.848.368Z"
    />
  </svg>
);

export default IcTick;
